import React, { FC, useState } from 'react';
import './Permissions.scss';
import PermissionGrid from './PermissionGrid/PermissionGrid';
import { GET_ROLE_PERMISSIONS } from '../../graphql/client/queries';
import { GetRolePermissions } from '../../types/schemaTypes';
import { useQuery } from '@apollo/client/react';
import { Error, Loading } from '../_common';

const Permissions: FC = (): React.ReactElement => {
    //hand down function to do boolean check
    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = 'SBS';
    const { data, loading, error, refetch } = useQuery<GetRolePermissions>(GET_ROLE_PERMISSIONS);
    document.title = 'Permissions';
    if (loading) {
        return <Loading />;
    }
    if (error) {
        return <Error error={error} />;
    }
    if (data) {
        const { getPermissionRoles } = data;
        return (
            <div className="Permission-PermissionContainer">
                <PermissionGrid permission={getPermissionRoles} refetch={refetch} />
            </div>
        );
    }
    return <div />;
};

export default Permissions;
